import {pushError} from '@js/actions/errorManagement';

export const exportGPXRide = (track, distance) => {
    const formData = new FormData();

    formData.append('exporter[map_points]', track);
    formData.append('exporter[distance]', distance);

    const csrfToken = document.getElementsByName('csrf-token')[0];
    const token = csrfToken?.getAttribute('content');
    const headers = {
        credentials: 'same-origin',
        headers: new Headers({
            'X-CSRF-Token': token,
            Accept: 'application/gpx+xml'
        })
    };

    return fetch('/api/v1/exporter/generate-gpx.gpx', {
        ...headers,
        method: 'POST',
        body: formData
    })
        .then(async (response) => ({
            filename: response.headers.get('content-disposition').split('filename=')[1].split(';')[0],
            blob: await response.blob()
        }))
        .then(({
                   filename,
                   blob
               }) => {
            filename = filename.replace(/^"|"$/g, '');

            const gpxFile = new File([blob], filename, {type: 'application/gpx+xml'});
            const exportUrl = URL.createObjectURL(gpxFile);

            const a = document.createElement('a');
            a.href = exportUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            setTimeout(() => URL.revokeObjectURL(exportUrl), 1000);
        })
        .catch((error) => {
            pushError(error);
        });
};
